import React, { Component } from "react";
import _ from "underscore";
import Api from "utils/api";
import ImportTable from "./components/import-table";
import ImportFilters from "./components/import-filters";
import { Centered } from "apps/importer/common/importer-styled-components";
import { withRouter } from "react-router-dom";
import { trackEvent } from "apps/importer/hooks/use-tracking";
import { launchToast } from "utils/show-toast";
import { compactObject } from "utils/utils";
import { Loading, Layout, Pagination } from "@evertrue/et-components";

const LIMIT = 25;

const hasChanged = (prev = {}, next = {}, keys) => {
  return _.any(keys, (key) => !_.isEqual(prev[key], next[key]));
};

class ImporterController extends Component {
  state = {
    data: [],
    loading: false,
  };

  componentDidMount() {
    trackEvent({ event: "Importer List Page" });
    this.fetchImports();
  }

  componentDidUpdate(prevProps) {
    if (
      hasChanged(this.props.state, prevProps.state, [
        "page",
        "sortProp",
        "searchValue",
        "statusValue",
        "activeFilters",
      ])
    ) {
      this.fetchImports();
    }
  }

  handleFileSearch = (searchValue) => {
    this.props.setState({ ...this.props.state, searchValue, page: 1 });
  };

  handleColumnSort = () => {
    const { sortProp, sortOrder } = this.props.state;
    this.props.setState({
      ...this.props.state,
      sortProp: sortProp === "desc" ? "asc" : "desc",
      sortOrder: !sortOrder,
      page: 1,
    });
  };

  handleFilterClear = () => {
    this.props.setState({
      ...this.props.state,
      searchValue: "",
      statusValue: [],
      activeFilters: {},
      page: 1,
    });
  };

  handleStatusFilterChange = (statusFilters = []) => {
    const statusValue = statusFilters.map((s) => s.value).flat();
    this.props.setState({
      ...this.props.state,
      statusValue,
      activeFilters: { status: statusFilters },
      page: 1,
    });
  };

  fetchImports = async () => {
    const {
      page,
      searchValue,
      sortProp,
      activeFilters,
      statusValue,
    } = this.props.state;
    const fetchKey = _.uniqueId();
    this.fetchKey = fetchKey;

    try {
      this.setState({ loading: true });
      const { data } = await Api.IMPORT.IMPORTS.get({
        params: compactObject({
          limit: LIMIT,
          offset: (page - 1) * LIMIT,
          sort_column: "created_at",
          sort_order: sortProp,
          filename: searchValue,
          status: statusValue,
          type: activeFilters.type,
        }),
      });

      if (fetchKey === this.fetchKey) {
        this.setState({ data: data, loading: false });
      }
    } catch (error) {
      console.log(error);
      launchToast({ message: error, type: "error" });
      if (fetchKey === this.fetchKey) this.setState({ loading: false });
    }
  };

  render() {
    const { data, loading } = this.state;
    const { page, searchValue, sortOrder, activeFilters } = this.props.state;

    return (
      <Layout
        className="importer-layout"
        subHeader={
          <ImportFilters
            searchValue={searchValue}
            onSearch={this.handleFileSearch}
            onFilterClear={this.handleFilterClear}
            activeFilters={activeFilters}
            onStatusFilterChange={this.handleStatusFilterChange}
          />
        }
        footer={
          <Centered>
            <Pagination
              className="import-table--pagination"
              onChange={(newPage) =>
                this.props.setState({ ...this.props.state, page: newPage })
              }
              page={page}
              total={Math.ceil(data.total / LIMIT) || 1}
              limit={LIMIT}
            />
          </Centered>
        }
      >
        {loading ? (
          <Loading />
        ) : (
          <ImportTable
            data={data.items || []}
            loading={loading}
            limit={LIMIT}
            onColumnSort={this.handleColumnSort}
            sortOrder={sortOrder}
          />
        )}
      </Layout>
    );
  }
}

export default withRouter(ImporterController);
